export default __webpack_public_path__ + "static/media/logo_social.96a8dda2.png";